/**
 * Recently viewed and recommendation product rails.
 */

import { getRecentlyViewed } from './recently-viewed.js';
import { renderProductCards } from './product-card-render.js';

function getConfig() {
	return window.doneCommerce || {};
}

async function apiFetch(path, options = {}) {
	const config = getConfig();
	const response = await fetch(`${config.restUrl}${path}`, {
		...options,
		headers: {
			'Content-Type': 'application/json',
			'X-WP-Nonce': config.nonce,
			...(options.headers || {}),
		},
	});

	if (!response.ok) {
		throw new Error('Request failed');
	}

	return response.json();
}

function getPdpProductId() {
	const productEl = document.querySelector('.single-product .product');
	const match = productEl?.className.match(/\bpost-(\d+)\b/);
	return match ? Number(match[1]) : 0;
}

async function renderRecentlyViewedRail() {
	const section = document.querySelector('[data-recently-viewed]');
	const grid = section?.querySelector('[data-recently-viewed-grid]');

	if (!section || !grid) {
		return;
	}

	const currentId = getPdpProductId();
	const ids = getRecentlyViewed().filter((id) => id !== currentId).slice(0, 4);

	if (!ids.length) {
		section.hidden = true;
		return;
	}

	try {
		const data = await apiFetch('done-commerce/v1/products/cards', {
			method: 'POST',
			body: JSON.stringify({ ids }),
		});

		const products = (data.products || []).slice(0, 4);
		if (!products.length) {
			section.hidden = true;
			return;
		}

		renderProductCards(grid, products);
		section.hidden = false;
	} catch {
		section.hidden = true;
	}
}

async function renderRecommendationsRail() {
	const section = document.querySelector('[data-recommendations]');
	const grid = section?.querySelector('[data-recommendations-grid]');
	const productId = getPdpProductId();

	if (!section || !grid || !productId) {
		return;
	}

	try {
		const data = await apiFetch(
			`done-commerce/v1/recommendations?product_id=${productId}&context=product_page&limit=4`
		);
		const products = (data.products || []).slice(0, 4);

		if (!products.length) {
			section.hidden = true;
			return;
		}

		renderProductCards(grid, products);
		section.hidden = false;
	} catch {
		section.hidden = true;
	}
}

async function renderCartRecommendationsRail() {
	const section = document.querySelector('[data-cart-recommendations]');
	const grid = section?.querySelector('[data-cart-recommendations-grid]');
	const productId = Number(section?.dataset.productId || 0);

	if (!section || !grid || !productId) {
		return;
	}

	try {
		const data = await apiFetch(
			`done-commerce/v1/recommendations?product_id=${productId}&context=cart_page&limit=8`
		);
		const products = data.products || [];

		if (!products.length) {
			section.hidden = true;
			return;
		}

		renderProductCards(grid, products);
		section.hidden = false;
	} catch {
		section.hidden = true;
	}
}

export function initProductRails() {
	if (document.body.classList.contains('woocommerce-cart')) {
		renderCartRecommendationsRail();
		return;
	}

	if (!document.body.classList.contains('single-product')) {
		return;
	}

	renderRecommendationsRail();
	renderRecentlyViewedRail();
}
